import { createContext } from "react";
import { TSwitchWithInputContext } from "./types";

export const SwitchWithInputContext = createContext<TSwitchWithInputContext>(null);
